import { CommitmentsGroupResponse } from "../../../../../../../../services/cloudchipr.api";

export const generateHighChartsTotalCostsFromCommitments = (
  data?: CommitmentsGroupResponse[],
) => {
  return data?.reduce(
    (result, item, index) => {
      const key = index.toString();

      const total =
        (item?.utilization?.amount ?? 0) + (item?.waste?.amount ?? 0);

      result.set(key, total);

      return result;
    },
    new Map() as Map<string, number>,
  );
};
